module.exports = __webpack_public_path__ + "static/media/logo-humanitas.5acd5a33.png";